import React, { Component } from 'react';
import { connect } from 'react-redux';
import { customParamChanged } from '../../actions/customParamsActions';
import { findMatchedType } from '../../utils/customParamsUtils';
import { Flex } from '@m/alchemy-ui/Flex';
import { Tooltip } from '@m/alchemy-ui/Tooltip';
import { NakedButton } from '@m/alchemy-ui/NakedButton';
import Well from '../dig-components/well';
import Input from '../dig-components/input';
import {
  StyledMoreItems,
  StyledTruncatedLabel,
  StyledNote,
  StyledCheckbox,
} from './StyledCustomParamsPane';

export class CustomParamsPane extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCustomParams: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  toggleCheckboxChange() {
    this.setState({
      showCustomParams: !this.state.showCustomParams
    });
  };

  handleInputChange(customParam, newCustomParamValue = null) {
    if (newCustomParamValue === '') {
      newCustomParamValue = null; //ignore empty strings
    }
    return this.props.dispatch(customParamChanged(customParam, newCustomParamValue));
  };

  render() {
    var paneObject = this;
    var customParamsListItems = this.props.customParams.map(customParam => {
      const matchedCustomParamType = findMatchedType(customParam.cps);
      const firstItem = customParam.cps[0];
      const otherItems = customParam.cps.filter((_, i) => i !== 0);
      const tooltipContents = otherItems.map(c => c.name).join(', ');

      const otherItemsTooltip =
        otherItems.length > 0 ? (
          <Tooltip
            zIndex={99999999}
            trigger={
              <NakedButton aria-label="Support">
                <StyledMoreItems>{` + ${otherItems.length} more`}</StyledMoreItems>
              </NakedButton>
            }
            mode="name"
            placement="top"
            contents={tooltipContents}
          />
        ) : null;

      return (
        <Flex direction="column" alignItems="normal" gap={5}>
          <Flex direction="row" alignItems="center">
            <StyledTruncatedLabel>{firstItem.name}</StyledTruncatedLabel>
            {otherItemsTooltip}
          </Flex>
          <Input
            key={customParam.key}
            id={customParam.key}
            type="text"
            objectType={matchedCustomParamType}
            value={customParam.value}
            onChange={newValue =>
              paneObject.handleInputChange(customParam, newValue)
            }
          />
        </Flex>
      );
    });

    return (
      <div className="custom-params-pane">
        <StyledCheckbox
          label="Simulate custom parameters"
          checked={this.state.showCustomParams}
          onChange={this.toggleCheckboxChange.bind(this)}
        />
        <Flex direction="column" gap={10}>
          <StyledNote> *You cannot simulate custom parameters that override the browsers existing "Window" attributes.</StyledNote>
          {this.state.showCustomParams ?
            <Well>{customParamsListItems}</Well>
           : null}
        </Flex>
      </div>
    );
  }
}

export default connect(state => state)(CustomParamsPane);
